<nav
  class="absolute h-0"
  [attr.aria-label]="'a11y.attendee.header.quick_access_menu.label' | translate"
>
  <a
    app-vtmn-play-button
    [href]="skipLinkUrl"
    fragment="main-content"
    class="right-full focus:right-auto focus:top-2 focus:left-2"
  >
    {{ 'attendee.header.menu.skip_link' | translate }}
  </a>
</nav>

<header class="header" [ngClass]="headerClass">
  <div class="container items-center py-2">
    <div class="col-span-6 lg:col-span-2">
      <a
        class="mr-auto"
        [routerLink]="homeLink"
        [attr.aria-label]="'a11y.header.logo.link' | translate"
      >
        <app-logo
          [height]="logoHeight"
          [name]="logo"
          [alt]="'a11y.header.logo.link' | translate"
        ></app-logo>
      </a>
    </div>

    <ng-content select="[navigation]"></ng-content>

    <div
      class="header__menus col-span-6 ml-auto flex items-center lg:col-span-6 lg:col-start-8"
      data-test="activity-creation"
    >
      <ng-content select="[tab-navigation]"></ng-content>

      <ng-content select="[right-content]"></ng-content>

      <app-cart
        *ngIf="isAttendee"
        class="flex items-center"
        (login)="loginButtonClicked()"
      ></app-cart>

      <app-header-login
        class="ml-auto flex-shrink-0"
        (clicked)="loginButtonClicked()"
        [user]="user"
        [menuItems]="dropdownMenuItems"
        [variant]="variant"
      ></app-header-login>
    </div>
  </div>
</header>
